import { render, staticRenderFns } from "./Dismissable.vue?vue&type=template&id=257b52cb&"
import script from "./Dismissable.vue?vue&type=script&lang=js&"
export * from "./Dismissable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports